export default __webpack_public_path__ + "static/media/050_brake.last.b1f36ce4.png";